<template>
  <div class="month bg-l-black cursor-pointer">
    <div class="dates">
      <div class="week flex size18 font-w-b margin-x-auto wz-bt wz-bl wz-bb" ref="week">
        <span class="wz-br">周日</span>
        <span class="wz-br">周一</span>
        <span class="wz-br">周二</span>
        <span class="wz-br">周三</span>
        <span class="wz-br">周四</span>
        <span class="wz-br">周五</span>
        <span class="wz-br">周六</span>
      </div>
      <div class="every-date flex flex-wrap margin-x-auto wz-bl">
        <div
          class="flex-col wz-br wz-bb"
          :class="{
            noCurrent: item.type != 'current',
            item: true,
            'blue-bg': !!item.color,
          }"
          :style="{
            minHeight: cellHeight + 'px',
          }"
          v-for="(item, index) in getDatesList"
          :key="index"
        >
          <div class="num">{{ item.value }}</div>
          <div class="text size14 flex-col flex-1">
            <p
              class="txt-hide1 width-full txt-left pad-x20 line-h24"
              :class="{
                'theme-red': i.type == 1,
                'theme-blue': i.type == 2,
              }"
              v-for="(i, j) in item.text ? item.text.slice(0, getTagPNum) : []"
              :key="j"
              @click="showDetail(i)"
            >
              {{ i.scheduleName }}
            </p>
            <p
              class="more white-s-nowrap pad-x10"
              v-if="item.color && item.text.length > getTagPNum"
              @click="toMore(item.value)"
            >
              更多{{ item.text.length - getTagPNum }}个日程
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inject: ["passTime", "callBack"],
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      cellHeight: 200,
    };
  },
  computed: {
    // 获取父级传来的时间
    now() {
      return this.passTime();
    },
    // 获取当前date
    current() {
      return this.now.getDate();
    },
    // 格式化
    nowDate() {
      return new Date(this.now.getFullYear(), this.now.getMonth() + 1, 0);
    },
    // 获取当月天数
    getDates() {
      return this.nowDate.getDate();
    },
    // 获取上月天数
    getLastDates() {
      return new Date(this.now.getFullYear(), this.now.getMonth(), 0).getDate();
    },
    // 获取当月第一天是周几
    getFirstDay() {
      return new Date(this.now.getFullYear(), this.now.getMonth(), 1).getDay();
    },
    // 获取当月最后一天是周几
    getLastDay() {
      return new Date(
        this.now.getFullYear(),
        this.now.getMonth(),
        this.getDates
      ).getDay();
    },
    // 格式化每天，凑成7的倍数
    getDatesList() {
      try {
        // 正常天数
        const normalDates = Array.from(
          {
            length: this.getDates,
          },
          (ele, index) => {
            return {
              value: index + 1,
              type: "current",
              color: this.list.length && this.list[index].list ? "green" : null,
              text:
                this.list.length && this.list[index].list
                  ? this.list[index].list
                  : [],
            };
          }
        );
        // 头部日期
        const headNum = this.getFirstDay == 0 ? 6 : this.getFirstDay - 1;
        const neadNullDates = Array.from(
          {
            length: headNum,
          },
          (ele, index) => ({
            value: this.getLastDates - index,
            type: "last",
          })
        );
        // 尾部日期
        const nextNullDates = Array.from(
          {
            length: this.getLastDay == 0 ? 0 : 7 - this.getLastDay,
          },
          (ele, index) => ({
            value: index + 1,
            type: "next",
          })
        );
        return neadNullDates.concat(normalDates).concat(nextNullDates);
      } catch (e) {}
    },
    // 获取可放置p标签个数 自适应
    getTagPNum() {
      const num = Math.ceil((this.cellHeight - 67) / 30);
      return num < 1 ? 1 : num;
    },
  },
  methods: {
    showDetail(i) {
      console.log(i);
      if (i.type == 2) {
        this.$emit("toDetail", i.id);
      } else if (i.type == 1) {
        this.$router.push({
          path: "/plan/detail",
          query: {
            drillId: i.drillId,
            type: 1,
            time: +this.passTime()
          },
        });
      }
    },
    toMore(value) {
      const current = `${this.passTime().getFullYear()}/${this.passTime().getMonth()+1}/${value}`
      // 更多日程
      this.$emit('toMore', current);
    },
    getHeight() {
      if (this.$refs.week)
        return Math.floor(this.$refs.week.offsetWidth / 7 + 10);
      return "200px";
    },
    // 点击date
    changeDate(item) {
      if (item.type == "current") {
        this.callBack(
          new Date(this.now.getFullYear(), this.now.getMonth(), +item.value)
        );
      } else if (item.type == "last") {
        this.callBack(
          new Date(this.now.getFullYear(), this.now.getMonth() - 1, +item.value)
        );
      } else if (item.type == "next") {
        this.callBack(
          new Date(this.now.getFullYear(), this.now.getMonth() + 1, +item.value)
        );
      }
    },
    // 上个月
    prevMonth() {
      this.callBack(
        new Date(this.now.getFullYear(), this.now.getMonth() - 1, 1)
      );
    },
    // 下个月
    nextMonth() {
      this.callBack(
        new Date(this.now.getFullYear(), this.now.getMonth() + 1, 1)
      );
    },
  },
  mounted() {
    this.cellHeight = this.getHeight();
    window.onresize = () => {
      this.cellHeight = this.getHeight();
    };
  },
};
</script>
<style lang='less' scoped>
@cell-size: 14.28%;
.month {
  user-select: none;
  .title {
    font-weight: bold;
    color: white;
    margin-bottom: 32px;
  }
  .dates {
    .week {
      span {
        width: @cell-size;
        height: 90px;
        color: #1890ff;
        text-align: center;
        line-height: 90px;
      }
    }
    .every-date {
      .item {
        width: @cell-size;
        color: #323232;
        text-align: center;
        font-size: 20px;
        line-height: 27px;
        position: relative;
        .num {
          padding: 21px 27px 0 0;
          text-align: right;
        }
        .text {
          padding: 15px 0 15px;
          p {
            margin-bottom: 10px;
          }
          .more {
            text-align: right;
            color: #bcbcbc;
            margin-bottom: 0;
          }
        }
      }
      .blue-bg {
        background: rgba(24, 144, 255, 0.05);
        position: relative;
        &:before {
          position: absolute;
          content: "";
          left: 0;
          top: 0;
          height: 100%;
          width: 6px;
          background: #1890ff;
        }
      }
      .theme-red {
        background: #f563ae;
        color: white;
      }
      .theme-blue {
        background: #38cbba;
        color: white;
      }
      .bar {
        position: absolute;
        left: 0;
        top: 0;
        width: 6px;
        height: 100%;
      }
      .noCurrent {
        color: #CCCCCC;
      }
    }
  }
}
</style>